import { render, staticRenderFns } from "./UserTree.vue?vue&type=template&id=6a50ddd9&scoped=true&"
import script from "./UserTree.vue?vue&type=script&lang=js&"
export * from "./UserTree.vue?vue&type=script&lang=js&"
import style0 from "./UserTree.vue?vue&type=style&index=0&id=6a50ddd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a50ddd9",
  null
  
)

export default component.exports